import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { SessionGuard } from './guards/session.guard';
import { AcceptContractComponent } from './pages/accept-contract/accept-contract.component';

import { InvoiceOptionsComponent } from './pages/invoice-options/invoice-options.component';
import { SendChargesComponent } from './pages/send-charges/send-charges.component';
import { SendDocumentsPhotoComponent } from './pages/send-documents-photo/send-documents-photo.component';
import { SimulationComponent } from './pages/simulation/simulation.component';
import { SuccessComponent } from './pages/success/success.component';
import { ErrorComponent } from './pages/error/error.component';
import { WelcomeComponent } from './pages/welcome/welcome.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent
  },
  {
    path: 'accept-contract',
    component: AcceptContractComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'invoice-options',
    component: InvoiceOptionsComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'send-documents-photo',
    component: SendDocumentsPhotoComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'simulation',
    component: SimulationComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'send-charges',
    component: SendChargesComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'success',
    component: SuccessComponent,
    canActivate: [SessionGuard]
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [SessionGuard]
  }, {
    path: 'welcome',
    component: WelcomeComponent,
    canActivate: [SessionGuard]
  },
  {
    path: '**',
    redirectTo: 'invoice-options',
    canActivate: [SessionGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
